/**
 * Capacitor native integration helpers.
 * Safe no-op when running in browser (web).
 */
import { Capacitor } from "@capacitor/core";

export const isNative = () => Capacitor.isNativePlatform();

export const initNativeApp = async () => {
  if (!isNative()) return;
  try {
    const { SplashScreen } = await import("@capacitor/splash-screen");
    const { StatusBar, Style } = await import("@capacitor/status-bar");
    // Splash auto-hides via config; keep manual hide as safety
    setTimeout(() => SplashScreen.hide().catch(() => {}), 1500);
    await StatusBar.setStyle({ style: Style.Dark }).catch(() => {});
    await StatusBar.setBackgroundColor({ color: "#0a0a0a" }).catch(() => {});
  } catch (e) {
    // ignore if plugin not available
  }
};

export const registerPushNotifications = async (onToken, onMessage) => {
  if (!isNative()) return;
  try {
    const { PushNotifications } = await import("@capacitor/push-notifications");
    let perm = await PushNotifications.checkPermissions();
    if (perm.receive !== "granted") {
      perm = await PushNotifications.requestPermissions();
    }
    if (perm.receive === "granted") {
      await PushNotifications.register();
      PushNotifications.addListener("registration", (token) => onToken?.(token.value));
      PushNotifications.addListener("pushNotificationReceived", (n) => onMessage?.(n));
    }
  } catch (e) {
    // plugin unavailable
  }
};
